// Font Awesome Scroll to Top Button implementation
document.addEventListener('DOMContentLoaded', function() {
  // First, make sure Font Awesome is loaded
  function loadFontAwesome() {
    if (!document.getElementById('font-awesome-css')) {
      const fontAwesomeLink = document.createElement('link');
      fontAwesomeLink.id = 'font-awesome-css';
      fontAwesomeLink.rel = 'stylesheet';
      fontAwesomeLink.href = '//netdna.bootstrapcdn.com/font-awesome/4.0.3/css/font-awesome.min.css';
      fontAwesomeLink.type = 'text/css';
      document.head.appendChild(fontAwesomeLink);
    }
  }
  
  // Load Font Awesome CSS
  loadFontAwesome();
  
  // Create the back-to-top anchor element
  const backToTopBtn = document.createElement('a');
  backToTopBtn.id = 'BackToTop';
  backToTopBtn.href = '#';
  backToTopBtn.title = 'Back to the top';
  backToTopBtn.className = 'back-to-top';
  
  // Create the icon element with the same classes from your reference
  const icon = document.createElement('i');
  icon.className = 'fa fa-arrow-circle-o-up fa-2x';
  
  // Append the icon to the anchor
  backToTopBtn.appendChild(icon);
  
  // Append the button to the body
  document.body.appendChild(backToTopBtn);
  
  // Add CSS styles
  const style = document.createElement('style');
  style.textContent = `
    .back-to-top {
      position: fixed;
      bottom: 20px;
      right: 20px;
      /* background-color: #ff0000;  Red background */
      color: #EA2C56;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      z-index: 9999;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s, visibility 0.3s;
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
    }
    
   /* .back-to-top:hover {
      background-color: #e00000;
      color: white;
      text-decoration: none;
    } */
    
    .back-to-top.show {
      opacity: 1;
      visibility: visible;
    }
    
    .fa-2x {
      font-size: 2em;
      vertical-align: middle;
    }
  `;
  document.head.appendChild(style);
  
  // Function to toggle button visibility
  function toggleBackToTopBtn() {
    if (window.pageYOffset > 300) {
      backToTopBtn.classList.add('show');
    } else {
      backToTopBtn.classList.remove('show');
    }
  }
  
  // Add scroll event listener
  window.addEventListener('scroll', toggleBackToTopBtn);
  
  // Handle click event
  backToTopBtn.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
  
  // Check initial scroll position
  toggleBackToTopBtn();
});